import i18n from '../../i18n'
import {
  FETCH_PRICING_REQUEST,
  FETCH_PRICING_SUCCESS,
  FETCH_PRICING_FAILURE,
} from '../reducers/pricingReducer'

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000/'
const SUPPORTED_LOCALES = new Set(['en', 'fr', 'ar', 'de', 'it'])

const normalizeLang = (lang) => {
  const raw = lang || i18n?.language || 'en'
  const short = String(raw).toLowerCase().split('-')[0]
  return SUPPORTED_LOCALES.has(short) ? short : 'en'
}

export const fetchPricing = (region = 'default', lang) => async dispatch => {
  dispatch({ type: FETCH_PRICING_REQUEST })
  try {
    const normalized = normalizeLang(lang)
    const res = await fetch(`${API_URL}api/pricing?region=${region}&lang=${normalized}`)
    if (!res.ok) throw new Error(`Failed to fetch pricing: ${res.status}`)
    const data = await res.json()
    dispatch({ type: FETCH_PRICING_SUCCESS, payload: data })
  } catch (error) {
    dispatch({ type: FETCH_PRICING_FAILURE, payload: error?.message || 'Failed to load pricing' })
  }
}
